import React from 'react';
interface ServicePlanProps {
  title: string;
  price: string;
  description: string;
  imageUrl: string;
  stripeLink: string;
}
const ServicePlan = ({
  title,
  price,
  description,
  imageUrl,
  stripeLink
}: ServicePlanProps) => {
  return <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform hover:scale-105" data-id="element-140">
      <div className="h-48 overflow-hidden" data-id="element-141">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover" data-id="element-142" />
      </div>
      <div className="p-6" data-id="element-143">
        <h3 className="text-xl font-bold text-[#869CE4] mb-2" data-id="element-144">{title}</h3>
        <p className="text-2xl font-bold text-[#f05a28] mb-4" data-id="element-145">{price}</p>
        <p className="text-gray-600 mb-6" data-id="element-146">{description}</p>
        <a href={stripeLink} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#869CE4] text-white text-center py-3 rounded-md font-semibold hover:bg-[#6a7fc7] transition" data-id="element-147">
          Purchase Plan
        </a>
      </div>
    </div>;
};
export default ServicePlan;